import React from 'react';
import '../styles/Booking.scss';

const Booking = () => {
    return (
        <section id="booking" className="booking">
            <div className="container" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="booking-container">
                    <h2>Begin Your Odyssey</h2>
                    <form className="booking-form" onSubmit={(e) => e.preventDefault()}>
                        <div className="form-group">
                            <input type="text" placeholder="Name" required />
                            <input type="email" placeholder="Email" required />
                        </div>
                        <div className="form-group two-col">
                            <input type="date" required />
                            <select>
                                <option>1 Passenger</option>
                                <option>2 Passengers</option>
                                <option>Family (4)</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <select>
                                <option value="">Select Destination</option>
                                <option value="moon">Moon Base Alpha</option>
                                <option value="mars">Mars Colony</option>
                                <option value="titan">Titan Resort</option>
                                <option value="europa">Europa Deep</option>
                            </select>
                        </div>
                        <button type="submit" className="btn-submit">Request Quote</button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Booking;
